<template>
	<div class="col-md-4 col-md-offset-4">
		<div class="panel panel-default drop-shadow">
			<div class="panel-heading panel-dark text-center">
				<b>RESET PASSWORD</b>
			</div>
			
            <!-- ERROR -->
			<div v-if="error_msg != ''"  class="panel-body">
				<div class="form-group text-left">
					Token error:<br><br>
                    <b>{{ error_msg }}</b>
				</div>
				<br><br><br>

				<div class="form-group">
					<div class="col-md-6 col-md-offset-6">
						<button  name="button"  type="submit"  class="btn btn-primary btn-block"
								 @click="complete()"
						>OK</button>
					</div>
				</div>
			</div>

            <!-- REQUEST NEW PASSWORD -->
			<div v-else                  class="panel-body">
				<div class="form-group">
					<div class="col-md-4">
						<label class="control-label text-right" style='padding-top:7px; width:100%;' >
							New Password:
						</label>
					</div>
					<div class="col-md-8 text-left">
						<input  name="password"  ref="password"  type="password"  class="form-control" style='width:100%; v-align:middle;'
								v-validate="'required|min:8|max:50'"
								v-model="password"
						>
						<span class="text-danger">{{ errors.first('password') }}</span>
					</div>
				</div>
				<br><br>

				<div class="form-group">
					<div class="col-md-4">
						<label class="control-label text-right" style='padding-top:7px; width:100%;' >
							Repeat Password:
						</label>
					</div>
					<div class="col-md-8 text-left">
						<input  name="c_password"  type="password"  class="form-control"  style='width:100%; v-align:middle;'
								v-model="c_password"
								v-validate="'required:true|confirmed:password'"
								data-vv-as="c_password"
						>
						<span class="text-danger">{{ errors.first('c_assword') }}</span>
					</div>
				</div>
				<br><br><br>

				<div class="form-group">
					<div class="col-md-6 col-md-offset-6">
						<button  v-if="requesting == false"
								 name="button"  type="submit"  class="btn btn-primary btn-block"
								 @click="set_password()"
    							 :disabled="errors.any() || !is_complete"
						>Submit</button>

						<button v-else  disabled
								name="button"   type="submit"  class="btn btn-primary btn-block">
							<i class="fas fa-circle-notch fa-spin"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
//imports...

export default {
	components: {
	},

	data() {
		return {
            requesting: false,
            error_msg:  '',

            token_code: this.$route.params.token_code,
            password:   '',
            c_password: '',
		};
	},

    computed: {
        is_complete() {
            return this.password && this.c_password;
        },
    },

    created() {
        // Check Token
        this.axios.get('api/check_token/'+this.token_code)
        .then(response => {
            this.requesting = false;
        })
        .catch(error => {
            this.requesting = false;
            this.error_msg  = error.response.data.message;
        });
    },

	methods: {
		// Set new password
		set_password() {
			this.requesting = true;
			
			this.$validator.validateAll()
			.then(() => {
				const post_data = {
                    code:       this.token_code,
                    password:   this.password,
                    c_password: this.c_password,
				};

				this.axios.post('api/reset', post_data)
				.then(response => {
					localStorage.setItem('api_token', response.data.api_token);
					this.$store.commit("USER_NAME", response.data.name);

					this.$parent.rerender_header();

					this.$notify({
						group:    'fs_success',
						title:    'Success',
						text:     'New password has been set.',
						type:     'success'
					});
					
                    this.$router.push('/files');
				})
				.catch(error => {
					this.requesting = false;
			
					var error_msg     = '';
					var error_details = '';
					if (error.response.data.message) {
						error_msg = error.response.data.message;	
					}
					
					if (error.response.data.error) {
						Object.keys(error.response.data.error).forEach(key => {
							error_details = error_details + error.response.data.error[key].toString() + "<br>";

							// load api errors into client errors
							this.errors.add({
								field: key,
								msg:   error.response.data.error[key].toString(),
							});
						});
					}

                    this.$notify({
                        group: 'fs_danger',
                        title: error_msg,
                        text:  error_details,
                        type:  'error'
                    });
				});
			})
			.catch(() => {
				this.requesting = false;
			
				this.$notify({
					group: 'fs_danger',
					title: 'Error',
					text:  this.errors.all(),
					type:  'error'
				});
			});
        },
        
		// Close form
		complete() {
            this.$router.push('/home-old');
		},
	}
};
</script>

<style lang="scss">
</style>